exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".forgot-password-buttons {\n  float: right;\n}\n\n.input-full-width {\n  width: 100%;\n}\n\n.forgot-password-error {\n  color: #C62828;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/login/forgot-password-dialog/forgot-password-dialog.component.css
// module id = 207
// module chunks = 1